import { addRule } from 'redux-ruleset'
import { isChannelSet } from 'utils/channel'

declare global {
  interface Window {
    /** shows the onetrust cookie layer */
    addOnetrustScript?: () => void
  }
}

if (typeof window !== 'undefined') {
  /**
   * we want to show the cookie popup
   * - when the b2x popup was already shown
   * - when the b2x popup was clicked
   */
  if (typeof window !== 'undefined') {
    const addOnetrustScript =
      window.addOnetrustScript ??
      (() => {
        // noop – OneTrust not configured
      })

    if (isChannelSet()) {
      // Channel ist bereits durch Cookie gesetzt. Um Hydration‑Mismatches zu vermeiden
      // (Script verändert DOM bevor React hydriert), laden wir das OneTrust‑Script
      // erst nach dem ersten Navigation/Change Event (effect‑ähnlich nach Hydration).
      addRule({
        id: 'feature/LOAD_COOKIE_SCRIPT_ON_NAV',
        target: 'navigation/LOCATION_CHANGED',
        output: '#script-add',
        addOnce: true,
        consequence: () => addOnetrustScript()
      })
    } else {
      // Kein Channel gesetzt -> B2xModal erscheint. Script erst nach Schließen laden.
      addRule({
        id: 'feature/LOAD_COOKIE_SCRIPT_ON_B2X_CLOSE',
        target: 'B2xModal/CLOSE',
        output: '#script-add',
        addOnce: true,
        consequence: () => addOnetrustScript()
      })
    }
  }
}
